import React from "react";

export interface BannerProps {
  message: string | React.ReactNode;
  type: "update" | "maintenance";
  actionLabel?: string;
  onAction?: () => void;
  onDismiss?: () => void;
}

/**
 * Shared banner component for updates and scheduled maintenance notifications
 */
const Banner: React.FC<BannerProps> = ({
  message,
  type,
  actionLabel,
  onAction,
  onDismiss,
}) => {
  const bgColor = type === "update" ? "#E38C76" : "#46ACC6";

  return (
    <div
      className="text-white flex items-center justify-center px-4 py-3 text-sm font-medium shadow-md"
      style={{ backgroundColor: bgColor }}
    >
      <span className="flex-1 text-center">{message}</span>
      <div className="ml-2 flex gap-2">
        {onAction && actionLabel && (
          <button
            className="px-3 py-1 bg-white rounded font-semibold hover:bg-gray-100 transition-colors"
            style={{ color: bgColor }}
            onClick={onAction}
          >
            {actionLabel}
          </button>
        )}
        {onDismiss && (
          <button
            className="px-3 py-1 bg-white/20 hover:bg-white/30 rounded font-semibold transition-colors"
            onClick={onDismiss}
            title="Dismiss"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default Banner;
